import { useStore } from '../store/hooks'
import { getAuthAccessToken } from '../utils/authToken'

export const useAuthHeaders = () => {
  const token = useStore(s => getAuthAccessToken(s.auth ?? {}))

  return { headers: { Authorization: `Bearer ${token}` } }
}
